import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button, Table } from 'reactstrap';
import { Translate, getSortState } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortDown, faSortUp } from '@fortawesome/free-solid-svg-icons';
import { ASC, DESC } from 'app/shared/util/pagination.constants';
import { overrideSortStateWithQueryParams } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities } from './grid-operator-capacity.reducer';

export const GridOperatorCapacity = () => {
  const dispatch = useAppDispatch();

  const pageLocation = useLocation();
  const navigate = useNavigate();

  const [sortState, setSortState] = useState(
    overrideSortStateWithQueryParams(getSortState(pageLocation, 'id'), pageLocation.search),
  );

  const gridOperatorCapacityList = useAppSelector(state => state.gridOperatorCapacity.entities);
  const loading = useAppSelector(state => state.gridOperatorCapacity.loading);

  const getAllEntities = () => {
    dispatch(
      getEntities({
        sort: `${sortState.sort},${sortState.order}`,
      }),
    );
  };

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?sort=${sortState.sort},${sortState.order}`;
    if (pageLocation.search !== endURL) {
      navigate(`${pageLocation.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [sortState.order, sortState.sort]);

  const sort = p => () => {
    setSortState({
      ...sortState,
      order: sortState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handleSyncList = () => {
    sortEntities();
  };

  const getSortIconByFieldName = (fieldName: string) => {
    const sortFieldName = sortState.sort;
    const order = sortState.order;
    if (sortFieldName !== fieldName) {
      return faSort;
    }
    return order === ASC ? faSortUp : faSortDown;
  };

  return (
    <div>
      <h2 id="grid-operator-capacity-heading" data-cy="GridOperatorCapacityHeading">
        <Translate contentKey="crawlerBackendApp.gridOperatorCapacity.home.title">Grid Operator Capacities</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="crawlerBackendApp.gridOperatorCapacity.home.refreshListLabel">
              Refresh List
            </Translate>
          </Button>
          <Link
            to="/grid-operator-capacity/new"
            className="btn btn-primary jh-create-entity"
            id="jh-create-entity"
            data-cy="entityCreateButton"
          >
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="crawlerBackendApp.gridOperatorCapacity.home.createLabel">
              Create new Grid Operator Capacity
            </Translate>
          </Link>
        </div>
      </h2>
      <div className="table-responsive">
        {gridOperatorCapacityList && gridOperatorCapacityList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th className="hand" onClick={sort('id')}>
                  <Translate contentKey="crawlerBackendApp.gridOperatorCapacity.id">ID</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('id')} />
                </th>
                <th className="hand" onClick={sort('capacityCode')}>
                  <Translate contentKey="crawlerBackendApp.gridOperatorCapacity.capacityCode">Capacity Code</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('capacityCode')} />
                </th>
                <th className="hand" onClick={sort('description')}>
                  <Translate contentKey="crawlerBackendApp.gridOperatorCapacity.description">Description</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('description')} />
                </th>
                <th className="hand" onClick={sort('meterType')}>
                  <Translate contentKey="crawlerBackendApp.gridOperatorCapacity.meterType">Meter Type</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('meterType')} />
                </th>
                <th className="hand" onClick={sort('productType')}>
                  <Translate contentKey="crawlerBackendApp.gridOperatorCapacity.productType">Product Type</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('productType')} />
                </th>
                <th className="hand" onClick={sort('type')}>
                  <Translate contentKey="crawlerBackendApp.gridOperatorCapacity.type">Type</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('type')} />
                </th>
                <th className="hand" onClick={sort('trancheLowerBound')}>
                  <Translate contentKey="crawlerBackendApp.gridOperatorCapacity.trancheLowerBound">
                    Tranche Lower Bound
                  </Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('trancheLowerBound')} />
                </th>
                <th className="hand" onClick={sort('trancheUpperBound')}>
                  <Translate contentKey="crawlerBackendApp.gridOperatorCapacity.trancheUpperBound">
                    Tranche Upper Bound
                  </Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('trancheUpperBound')} />
                </th>
                <th>
                  <Translate contentKey="crawlerBackendApp.gridOperatorCapacity.gridOperator">Grid Operator</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="crawlerBackendApp.gridOperatorCapacity.productOfferingPrice">
                    Product Offering Price
                  </Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {gridOperatorCapacityList.map((gridOperatorCapacity, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`/grid-operator-capacity/${gridOperatorCapacity.id}`} color="link" size="sm">
                      {gridOperatorCapacity.id}
                    </Button>
                  </td>
                  <td>{gridOperatorCapacity.capacityCode}</td>
                  <td>{gridOperatorCapacity.description}</td>
                  <td>
                    <Translate contentKey={`crawlerBackendApp.MeterType.${gridOperatorCapacity.meterType}`} />
                  </td>
                  <td>
                    <Translate contentKey={`crawlerBackendApp.ProductType.${gridOperatorCapacity.productType}`} />
                  </td>
                  <td>
                    <Translate contentKey={`crawlerBackendApp.GridOperatorCostType.${gridOperatorCapacity.type}`} />
                  </td>
                  <td>{gridOperatorCapacity.trancheLowerBound}</td>
                  <td>{gridOperatorCapacity.trancheUpperBound}</td>
                  <td>
                    {gridOperatorCapacity.gridOperator ? (
                      <Link to={`/grid-operator/${gridOperatorCapacity.gridOperator.id}`}>
                        {gridOperatorCapacity.gridOperator.ean}
                      </Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {gridOperatorCapacity.productOfferingPrices
                      ? gridOperatorCapacity.productOfferingPrices.map((val, j) => (
                          <span key={j}>
                            <Link to={`/product-offering-price/${val.id}`}>{val.id}</Link>
                            {j === gridOperatorCapacity.productOfferingPrices.length - 1 ? '' : ', '}
                          </span>
                        ))
                      : null}
                  </td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button
                        tag={Link}
                        to={`/grid-operator-capacity/${gridOperatorCapacity.id}`}
                        color="info"
                        size="sm"
                        data-cy="entityDetailsButton"
                      >
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`/grid-operator-capacity/${gridOperatorCapacity.id}/edit`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        onClick={() =>
                          (window.location.href = `/grid-operator-capacity/${gridOperatorCapacity.id}/delete`)
                        }
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="crawlerBackendApp.gridOperatorCapacity.home.notFound">
                No Grid Operator Capacities found
              </Translate>
            </div>
          )
        )}
      </div>
    </div>
  );
};

export default GridOperatorCapacity;
